import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";

export default function Studies() {
  return (
    <div data-testid="studies-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>Estudios Normativos</h1>
        <PDFButton endpoint="/pdf/module/studies" filename="reporte_estudios.pdf" label="Reporte PDF" />
      </div>
      <CrudTable
        collection="studies"
        testIdPrefix="studies"
        fields={[
          { key: "name", label: "Nombre", required: true, full: true },
          { key: "type", label: "Tipo" },
          { key: "norm", label: "Norma aplicable" },
          { key: "frequency", label: "Frecuencia", type: "select", options: ["Mensual", "Trimestral", "Semestral", "Anual", "Bianual"] },
          { key: "provider", label: "Proveedor" },
          { key: "ema_accredited", label: "Acreditación EMA", type: "checkbox" },
          { key: "last_study", label: "Último estudio", type: "date" },
          { key: "next_study", label: "Próximo estudio", type: "date" },
          { key: "status", label: "Status", type: "select", options: ["Vigente", "Por vencer", "Vencido"] },
          { key: "general_result", label: "Resultado general", type: "select", options: ["CUMPLE", "INCUMPLIMIENTO PARCIAL", "INCUMPLIMIENTO", "Pendiente"] },
        ]}
      />
    </div>
  );
}
